// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

// Types
import { Theme } from '../../../../../../types/theme';

/** Reusable styles */
const borderColor = (
  { theme }: { theme: Theme },
) => theme.color.crusherDashboard.motorControlDrawer.borderColor;

export const MotorControlContainer = styled.div`
  width: 100%;
  display: flex;
  border-radius: 4px;
  flex-direction: column;
  gap: 1.25rem;
`;

export const BorderBottomContainer = styled.div`
  border-bottom: 1px solid ${({
    theme,
  }) => theme.color.crusherDashboard.motorControlDrawer.borderColor};
`;

export const ControlModeContainer = styled.div`
  width: 100%;
`;

export const HorimeterContainer = styled.div`
  width: 100%;
  flex: 1;
  border: 1px solid ${borderColor};
  border-radius: 4px;
`;

export const FeederControlModeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid ${borderColor};
  padding: 0.75rem 1rem;
  border-radius: 4px 4px 0px 0px;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.xl}px) {
    padding: 1.5rem;
    border-radius: 4px 0px 0px 4px;
  };
`;

export const LubeTankHeaterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-left: 1px solid ${borderColor};
  border-right: 1px solid ${borderColor};
  border-bottom: 1px solid ${borderColor};
  padding: 0.75rem 1rem;
  border-radius: 0px 0px 4px 4px;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.xl}px) {
    padding: 1.5rem;
    border-left: none;
    border-bottom: 1px solid ${borderColor};
    border-right: 1px solid ${borderColor};
    border-top: 1px solid ${borderColor};
    border-radius: 0px 4px 4px 0px;
  };
`;

export const HorimeterTitleContainer = styled.div`
  border-bottom: 1px solid ${borderColor};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.xl}px) {
    padding: 1.5rem;
  };
`;

export const LubeUnitContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-bottom: 1px solid ${borderColor};
  padding: 0.75rem 1rem;
  width: 100%;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.xl}px) {
    padding: 1.5rem;
  };
`;

export const DischargeConveyorContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-bottom: 1px solid ${borderColor};
  padding: 0.75rem 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.xl}px) {
    padding: 1.5rem;
    border-left: 1px solid ${borderColor};
    margin-right: -1px;
  };
`;

export const CrusherMotor1Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-bottom: 1px solid ${borderColor};
  padding: 0.75rem 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.xl}px) {
    padding: 1.5rem;
    border-bottom: none;
  };
`;

export const CrusherMotor2Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.75rem 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.xl}px) {
    padding: 1.5rem;
    border-left: 1px solid ${borderColor};
    margin-right: -1px;
  };
`;

export const FeederContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  width: 100%;
  border-top: 1px solid ${borderColor};

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.xl}px) {
    padding: 1.5rem;
  };
`;

export const BinFeederContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-top: 1px solid ${borderColor};
  padding: 0.75rem 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.xl}px) {
    padding: 1.5rem;
    border-left: 1px solid ${borderColor};
    margin-right: -1px;
  };
`;

export const HorimetersStatusContent = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const HoursContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
